import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, Heart, Loader2 } from 'lucide-react';
import { API } from '../config/api';

export default function DonateSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [donation, setDonation] = useState(null);

  const sessionId = searchParams.get('donation_session_id');

  useEffect(() => {
    if (sessionId) {
      checkPaymentStatus();
    } else {
      setLoading(false);
    }
  }, [sessionId]);

  const checkPaymentStatus = async () => {
    try {
      const response = await fetch(`${API}/donations/status/${sessionId}`);
      if (response.ok) {
        const data = await response.json();
        setDonation(data);
      }
    } catch (err) {
      console.error('[DonateSuccess] Error:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4" data-testid="donate-success-page">
      <Card className="max-w-md w-full p-8 text-center glass-card border-border">
        <div className="w-20 h-20 rounded-full bg-green-500/20 flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-10 h-10 text-green-500" />
        </div>
        
        <h1 className="text-2xl font-bold mb-2">Thank You!</h1>
        <p className="text-muted-foreground mb-4">
          Your donation helps keep DMV Soundstage running and supports local creators across the DMV.
        </p>
        
        {donation && (
          <div className="bg-muted/30 rounded-lg p-4 mb-6">
            <p className="text-sm text-muted-foreground">Amount donated</p>
            <p className="text-2xl font-bold text-green-500">${donation.amount?.toFixed(2)}</p>
          </div>
        )}
        
        <div className="flex flex-col gap-3">
          <Button onClick={() => navigate('/home')} data-testid="donate-go-home">
            <Heart className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
          <Button variant="ghost" onClick={() => navigate('/discover')}>
            Discover Music
          </Button>
        </div>
      </Card>
    </div>
  );
}
